<app-tab-layout [loading]="loading()" [error]="error">
  @if(initialized()) {
  <app-api-table
    [endpoint]="'/visits/tables/products-performance'"
    [name]="'Products Performance'"
    [chartColumn]="'Name'"
  ></app-api-table>
  }
</app-tab-layout>
